// export const aZ123Regex = /^[\w- ]+$/;
// export const zipRegex = /^\d{5}$/;
// export const cityRegex = /^[a-zA-Z\u0080-\u024F]+(?:([\ \-\']|(\.\ ))[a-zA-Z\u0080-\u024F]+)*$/;
// export const creditCardRegex = /^\d{4}[- ]?(\d{4,6})[- ]?(\d{4,5})([- ]?(\d{4}))?$/;
// export const firstLastRegex = /\w+[\w.\- ]+\w+/;
// export const microchipRegex = /^([0-9]{8,15})$/;
// export const monthRegex = /^(0|1|2|3|4|5|6|7|8|9|10|11)$/;
// export const numbersOnlyRegex = /^[0-9]+$/;
// export const petNameRegex = /^[a-zA-Z0-9\s]*$/;
// export const noNumbersRegex = /^([^0-9]*)$/;
// export const noEmptyStringRegex = /^(.*)?\S+(.*)?$/gm;
// export const phoneRegex = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/;
// export const quebecRegex = /^[GHJ]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/i;
// export const uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi;
// export const yearRegex = /^([2-9][0-9)]{3})$/;
// export const hasLettersRegex = /[a-zA-Z]/;
// Checks for relative link, where value is "/" followed by a char that is not "/".
// True: "/some-relative-link"
// False: "/"
// False: "//"
export const isRelativeLink = /^\/[^/]/;
// Checks for relative link, where value is "#" followed by a char that is not "#".
// True: "#some-jump-link"
// False: "#"
// False: "##"
export const isHashLink = /^#[^#]/;
// Checks for leading non alpha characters
// True: "1. First Item"
// False: "First Item"
export const leadingNonAlphaChars = /^[^a-zA-Z]+/;
